import { CategoryDetail } from '../../components/category/detail';
import { CollectionDetail } from '../../components/collection/detail';
import NotFound from '../../components/common/not-found';
import PageDetail from '../../components/page/detail';
import {
  getCategorySlugs,
  getCategoryStaticPaths,
  getCategoryStaticProps,
} from '../../lib/category';
import {
  getCollectionSlugs,
  getCollectionStaticPaths,
  getCollectionStaticProps,
} from '../../lib/collection';
import {
  getCustomTypeStaticPaths,
  getCustomTypeStaticProps,
  pagePathQuery,
  pageQuery,
} from '../../lib/custom-type';

export default function Slug(props) {
  if (props) {
    if (props.customType) {
      return <PageDetail {...props} />;
    } else if (props.category) {
      return <CategoryDetail {...props} />;
    } else if (props.collection) {
      return <CollectionDetail {...props} />;
    }
    return <NotFound {...props} />;
  }
  return <NotFound preview={true} />;
}

export async function getStaticProps(props) {
  // check if the current page is a category or a prismic page
  const categorySlugs = [...(await getCategorySlugs())];

  if (categorySlugs.includes(props.params.slug)) {
    return await getCategoryStaticProps(props);
  }

  const collectionSlugs = await getCollectionSlugs();
  if (collectionSlugs.includes(props.params.slug)) {
    return await getCollectionStaticProps(props);
  }

  return await getCustomTypeStaticProps({
    gqlQuery: pageQuery,
    variables: { uid: props.params.slug, lang: props.locale },
    ...props,
  });
}

export async function getStaticPaths() {
  const customTypes = await getCustomTypeStaticPaths(pagePathQuery, 'slug');
  const categories = await getCategoryStaticPaths();
  const collections = await getCollectionStaticPaths();

  const de = [
    ...customTypes.paths,
    ...categories.paths,
    ...collections.paths,
  ].map((t) => {
    t.locale = 'de';
    return t;
  });
  const fr = de.map((t) => {
    return { params: t.params, locale: 'fr' };
  });

  return {
    paths: [...de, ...fr],
    fallback: false, //!STATIC_BUILD,
  };
}
